import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
  TimePeriodUtils,
} from "app/shared";
import { ChartDefinitions, ChartDefinition } from "../../../chartDefinitions.config";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { ManualsDownloadedMostConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "manuals-downloaded-most-details",
  templateUrl: "./manuals-downloaded-most-details.component.html",
  standalone: false,
})
export class ManualsDownloadedMostDetailsComponent
  extends BaseDetailsLogic<ManualsDownloadedMostConfig>
  implements OnInit, OnDestroy
{

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, ManualsDownloadedMostConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
      this.detectSettingsChange();
      this.refreshDataFromFilters();
  }

  get selectedNumberResults(): number {
    return this.config?.top || 10;
  }

  set selectedNumberResults(value: number) {
    this.config.top = value;
      this.detectSettingsChange();
      this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod: 'Pick a time period to see which manuals were downloaded the most during that time. For example, you can look at the most downloaded manuals from the last month or year. This helps you find out which manuals are the most popular.',
      numberResults: 'Set how many manuals you want to see in the list. For example, if you enter 10, you will see the 10 manuals with the most downloads. This helps you focus on the most popular manuals so you know what people are interested in.'
    };
  }
}
